export default [
  {
    path: "/field5ydhzql", // 无视频
    name: "field5ydhzql",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field5ydks")
  },
  {
    path: "/field8ydhzql", // 无视频
    name: "field8ydhzql",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field8ydks")
  },
  {
    path: "/field9ydhzql",
    name: "field9ydhzql",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field9ydks")
  },
  {
    path: "/field12ydhzql", // 无视频
    name: "field12ydhzql",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field12ydks")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/hzql.js